import PdfIcon from '../../../assets/icons/pdf.svg?react';
import DocIcon from '../../../assets/icons/doc.svg?react';
import XlsIcon from '../../../assets/icons/xls.svg?react';
import TxtIcon from '../../../assets/icons/txt.svg?react';
import PptIcon from '../../../assets/icons/ppt.svg?react';
import RawIcon from '../../../assets/icons/raw.svg?react';
import JpegIcon from '../../../assets/icons/photo.svg?react';
import ZipIcon from '../../../assets/icons/zip.svg?react';

export function getFileIcon(extension: string | undefined | null) {
  switch (extension) {
    case 'zip':
      return <ZipIcon width={40} height={40} />;
    case 'pdf':
      return <PdfIcon width={40} height={40} />;
    case 'png':
    case 'jpg':
    case 'jpeg':
      return <JpegIcon width={40} height={40} />;
    case 'docx':
    case 'doc':
      return <DocIcon width={40} height={40} />;
    case 'csv':
    case 'xlsx':
    case 'xls':
      return <XlsIcon width={40} height={40} />;
    case 'pptx':
    case 'ppt':
      return <PptIcon width={40} height={40} />;
    case 'txt':
      return <TxtIcon width={40} height={40} />;
    default: {
      return <RawIcon width={40} height={40} />;
    }
  }
}